import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Home as HomeIcon, Users, ArrowRight } from 'lucide-react';
import { LogoHorizontal } from '../components/Logo';
import { useAuth } from '../contexts/AuthContext';

export default function SetupFamily() {
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const [hoveredCard, setHoveredCard] = useState(null);

    return (
        <div className="min-h-screen bg-surface app-shell flex flex-col py-8 px-6">
            <div className="flex justify-center mb-6"><LogoHorizontal size="lg" /></div>

            <div className="text-center mb-8 fade-up">
                <h1 className="text-3xl font-bold text-brand-navy tracking-tight">¡Hola{user?.name ? `, ${user.name.split(' ')[0]}` : ''}!</h1>
                <p className="text-gray-500 mt-2">Para empezar, configura tu familia</p>
            </div>

            <div className="space-y-4 fade-up fade-up-delay-1">
                <button
                    onClick={() => navigate('/crear-familia')}
                    onMouseEnter={() => setHoveredCard('create')}
                    onMouseLeave={() => setHoveredCard(null)}
                    className="w-full bg-white border-2 border-transparent hover:border-brand rounded-[24px] p-6 text-left shadow-card transition-all active:scale-[0.98]"
                    data-testid="setup-create-family-btn"
                >
                    <div className="flex items-center gap-4">
                        <div className="w-14 h-14 bg-brand/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                            <HomeIcon className="w-7 h-7 text-brand" />
                        </div>
                        <div className="flex-1">
                            <h3 className="text-lg font-bold text-brand-navy">Crear una familia nueva</h3>
                            <p className="text-sm text-gray-500 mt-0.5">Tú serás el administrador y podrás invitar a otros miembros</p>
                        </div>
                        <ArrowRight className={`w-5 h-5 text-gray-400 transition ${hoveredCard === 'create' ? 'translate-x-1 text-brand' : ''}`} />
                    </div>
                </button>

                <button
                    onClick={() => navigate('/unirte')}
                    onMouseEnter={() => setHoveredCard('join')}
                    onMouseLeave={() => setHoveredCard(null)}
                    className="w-full bg-white border-2 border-transparent hover:border-brand rounded-[24px] p-6 text-left shadow-card transition-all active:scale-[0.98]"
                    data-testid="setup-join-family-btn"
                >
                    <div className="flex items-center gap-4">
                        <div className="w-14 h-14 bg-emerald-100 rounded-2xl flex items-center justify-center flex-shrink-0">
                            <Users className="w-7 h-7 text-emerald-500" />
                        </div>
                        <div className="flex-1">
                            <h3 className="text-lg font-bold text-brand-navy">Unirme a una familia</h3>
                            <p className="text-sm text-gray-500 mt-0.5">Si tienes un código de invitación, úsalo aquí</p>
                        </div>
                        <ArrowRight className={`w-5 h-5 text-gray-400 transition ${hoveredCard === 'join' ? 'translate-x-1 text-brand' : ''}`} />
                    </div>
                </button>
            </div>

            <button onClick={logout} className="mt-auto mb-2 text-sm text-gray-400 hover:text-gray-600 self-center" data-testid="setup-logout-btn">
                Cerrar sesión
            </button>
        </div>
    );
}
